import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import config from './config'
import './filter'

import vuetify from './plugins/vuetify'
import helpers from './plugins/helpers'

import VeeValidate from 'vee-validate'
import axios from 'axios'
import wysiwyg from 'vue-wysiwyg'

import VueCroppie from 'vue-croppie'
import 'croppie/croppie.css'

import YmapPlugin from 'vue-yandex-maps'

import JsonExcel from 'vue-json-excel'

Vue.component('downloadExcel', JsonExcel)
Vue.use(VeeValidate)
Vue.use(wysiwyg)
Vue.use(VueCroppie)
Vue.use(helpers)

const settings = {
    apiKey: '482df77a-3613-46f9-aa9b-e644c4882eea',
    lang: 'ru_RU',
    coordorder: 'latlong',
    version: '2.1'
}
Vue.use(YmapPlugin, settings)

Vue.config.productionTip = false

Vue.http = Vue.prototype.$http = axios
Vue.config.productionTip = false


let apiToken = null

let projectKey = sessionStorage.getItem('projectKey')
let user = sessionStorage.getItem('user')
if (user) {
    let userObject = JSON.parse(user)
    if (userObject) {
        apiToken = userObject.data.api_token
    }
}

axios.defaults.baseURL = config.apiUrl;
axios.defaults.headers.common['pl'] = config.pl;
axios.defaults.headers.common['project-key'] = projectKey
axios.defaults.headers.common['api-token'] = apiToken
axios.defaults.headers.common['dashboard'] = true

const vm = new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')

Vue.app = Vue.prototype.$app = vm
